var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['alert', _vm.type]},[_c('eva-icon',{attrs:{"name":_vm.icon || _vm.typeIcon,"fill":"white"}}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }